import type { Dict } from './index';

// Fransızca sözlük — Claude tarafından elle çevrildi (06.08.2026), makine
// çevirisi kullanılmadı. en.ts ile aynı yapıda olmalı (tip zorunlu kılar).
export const fr: Dict = {
  signInMethods: {
    googleLinked: "Compte Google associé.",
    googleCodeSent: "Un code a été envoyé à ton numéro enregistré se terminant par {phone}.",
    googleChooseHint: "Le compte Google choisi sera associé pour te connecter à ce compte nosubject.",
    googleStatusUnknown: "Impossible de vérifier la connexion Google. Réessaie.",
    googleLinkIntro: "Vérifie le numéro de téléphone enregistré sur ce compte avant d’associer Google.",
    googleLinkFailed: "Impossible de terminer la demande. Réessaie.",
    googleSendCode: "Envoyer le code de vérification",
    googleCodeLabel: "Code de vérification",
    googleStartAgain: "Recommencer",
    googleContinue: "Continuer avec Google",
    googleFailed: "La connexion avec Google n’a pas pu aboutir. Réessaie.",
    googleNotLinked: "Ce compte Google n’est pas encore associé à un compte nosubject.",
    googleUnavailable: "La connexion avec Google n’est pas encore disponible.",
    title: "Modes de connexion",
    intro: "Cette rubrique est en préparation. Les options de gestion des modes de connexion seront ajoutées ultérieurement.",
    identity: "Vérification d’identité",
    identityInfo: "La vérification de ton identité est distincte de la connexion à ton compte.",
  },
  safety: {
    title: 'Numéro de sécurité',
    compare: 'Compare ce numéro avec {name}. S’il est identique, personne ne peut s’interposer pour lire les messages.',
    explainInfo: 'Le numéro est calculé à partir des clés de chiffrement de tous les appareils actuels des deux personnes, et il est le même sur les deux téléphones. Si l’une d’elles ajoute un appareil, comme un nouveau téléphone ou le web, le numéro change. Compare-le alors à nouveau. La vérification n’est enregistrée que sur cet appareil.',
    qrLabel: 'Code QR du numéro de sécurité',
    verified: 'Vérifié',
    notVerified: 'Non vérifié',
    markVerified: 'Marquer comme vérifié',
    clearVerified: 'Retirer la vérification',
    peerUnavailable: 'Le chiffrement n’est pas encore actif avec cette personne.',
    selfUnavailable: 'La clé de chiffrement de cet appareil n’est pas encore prête.',
    loadFailed: 'Impossible de charger le numéro de sécurité.',
  },
  backup: {
    title: 'Sauvegarde des discussions',
    explainInfo: 'Ton historique reste sur cet appareil. La sauvegarde le chiffre avec ton code de récupération et le garde sur le serveur ; nous ne pouvons pas l’ouvrir.',
    create: 'Créer une sauvegarde',
    refresh: 'Mettre à jour la sauvegarde',
    codeTitle: 'Ton code de récupération',
    codeWarning: 'Garde ce code en lieu sûr. Si tu le perds, ton historique ne revient pas, et nous ne pouvons pas l’ouvrir non plus.',
    restoreTitle: 'Restaurer l’historique',
    restorePlaceholder: 'Code de récupération',
    restore: 'Restaurer',
    restored: '{count} messages restaurés.',
    restoreFailed: 'Impossible d’ouvrir l’historique. Vérifie le code.',
    failed: 'La sauvegarde a échoué.',
  },
  common: {
    infoHide: 'Masquer l’explication : {subject}',
    infoShow: 'Afficher l’explication : {subject}',
    continue: 'Continuer',
    cancel: 'Annuler',
    close: 'Fermer',
    save: 'Enregistrer',
    done: 'Terminé',
    retry: 'Réessayer',
    error: 'Erreur',
    back: 'Retour',
    search: 'Rechercher…',
    loading: 'Chargement',
    remove: 'Retirer',
    offline: 'Le serveur est injoignable. Vérifie ta connexion.',
    sessionExpired: 'Ta session a expiré. Reconnecte-toi.',
    tooManyRequests: 'Trop de requêtes. Attends un peu et réessaie.',
  },
  time: {
    now: 'à l’instant',
    minAgo: 'il y a {n} min',
    hourAgo: 'il y a {n} h',
    yesterday: 'hier',
    dayAgo: 'il y a {n} jours',
    weekAgo: 'il y a {n} semaines',
    weekAgoOne: 'il y a {n} semaine',
    today: 'Aujourd’hui',
    dayYesterday: 'Hier',
  },
  phone: {
    sendFailed: "Impossible d’envoyer le code. Réessaie.",
    subtitle: 'Saisis ton numéro de téléphone',
    selectCountry: 'Pays / région',
    countrySearch: 'Rechercher un pays…',
    architectureLink: 'Architecture technique et feuille de route ↗',

  },
  otp: {
    verifyFailed: "Impossible de vérifier le code. Réessaie.",
    invalidCode: "Le code est incorrect ou a expiré.",
    rateLimited: "Trop de tentatives. Réessaie plus tard.",
    title: 'Saisis le code',
    sentTo: 'Nous avons envoyé un SMS au {phone}',
    verify: 'Vérifier',
    resend: 'Renvoyer',

    tooManyAttempts: 'Trop de tentatives. Attends un peu et réessaie.',

    resendSent: 'Un nouveau code a été envoyé.',
    resendFailed: 'Le code n’a pas pu être envoyé. Vérifie ta connexion et réessaie.',
    resendWait: 'Tu peux redemander dans {n} s',
  },
  university: {
    title: 'Quelle est ton université ?',
    subtitle: 'Recherche ton université',
    placeholder: 'Harvard, Oxford…',
    skip: 'Passer',
  },
  profession: {
    title: 'Que fais-tu dans la vie ?',
    subtitle: 'Recherche ta profession',
    placeholder: 'Enseignant, développeur, infirmier…',
    skip: 'Passer',
  },
  isco: {
    '0': 'Forces armées',
    '1': 'Directeurs, cadres de direction et gérants',
    '2': 'Professions intellectuelles et scientifiques',
    '3': 'Professions intermédiaires',
    '4': 'Employés de type administratif',
    '5': 'Personnel des services et vendeurs',
    '6': 'Agriculteurs et ouvriers qualifiés de l’agriculture, de la sylviculture et de la pêche',
    '7': 'Métiers qualifiés de l’industrie et de l’artisanat',
    '8': 'Conducteurs d’installations et de machines',
    '9': 'Professions élémentaires',
  },
  isced: {
    '5': 'Diplôme technique',
    '6': 'Licence',
    '7': 'Master',
    '8': 'Doctorat',
  },
  profileCreate: {
    photoPickerFailed: "Impossible d’ouvrir la photothèque.",
    title: 'Crée ton profil',
    addPhoto: 'Ajouter une photo',
    name: 'Ton prénom',
    surname: 'Ton nom',
  },
  terms: {
    title: 'Avant de commencer',
    age: 'J’ai plus de 18 ans',
    accept: 'J’ai lu et j’accepte les Conditions d’utilisation et la Politique de confidentialité',
    termsLink: 'Conditions d’utilisation',
    privacyLink: 'Politique de confidentialité',
    continue: 'Accepter et continuer',
    saveFailed: 'Ton consentement n’a pas pu être enregistré. Vérifie ta connexion et réessaie.',
    docPlaceholder: 'Ce document sera bientôt publié.',
  },
  locationConsent: {
    title: 'Ta position, seulement si tu le souhaites',
    body: 'Nous avons besoin de l’autorisation d’accéder à ta position pour proposer le district et la ville lorsque tu prends une photo.',
    privacy: 'Cette étape ne consulte pas ta position. Elle n’est utilisée qu’après une prise de vue réussie et tes coordonnées exactes ne sont pas conservées. Tu pourras modifier cette autorisation dans les réglages de l’appareil.',
    allow: 'Autoriser la localisation',
    later: 'Pas maintenant',
  },
  discover: {
    title: "Découvrir",
    categories: "Catégories professionnelles",
    categoryHint: "Découvrez des personnes selon les professions indiquées sur leur profil.",
    all: "Toutes",
    reset: "Effacer les filtres",
    failed: 'Impossible de charger',
    free: 'Gratuit',
    empty: 'Personne pour le moment',
  },
  userProfile: {
    smsVerifiedOn: "Téléphone vérifié par SMS · {date}",
    googleLinkedOn: "Compte Google associé · {date}",
    contactProofNote: "Confirme l’accès au téléphone ou au compte Google, pas l’identité de la personne.",
    failed: 'Impossible de charger le profil',
    sendMessage: 'Envoyer un message',
    buyTime: 'Proposer une rencontre',
    block: 'Bloquer',
    blockedNotice: '{name} est bloqué. Messages, appels et rencontres désactivés.',
    blockTitle: 'Bloquer {name} ?',
    blockMessage: 'Cette personne ne pourra plus t’envoyer de messages ni te trouver dans l’onglet Découvrir.',
    blockConfirm: 'Bloquer',
  },
  callHistory: {
    empty: 'Aucun appel pour le moment',
    tabAll: 'Tous',
    tabMissed: 'Manqués',
    emptyMissed: 'Aucun appel manqué',
    failed: 'Impossible de charger les appels',
    outgoing: 'Sortant',
    incoming: 'Entrant',
    missed: 'Manqué',
    declined: 'Refusé',
    cancelled: 'Annulé',
  },
  call: {
    title: 'Appel vocal',
    calling: 'Appel en cours…',
    incoming: 'Appel entrant',
    connecting: 'Connexion…',
    connected: 'Connecté',
    reconnecting: 'Reconnexion…',
    logAnswered: 'Appel vocal',
    logAnsweredVideo: 'Appel vidéo',
    logNoAnswer: 'Pas de réponse',
    logMissed: 'Appel manqué',
    logDeclined: 'Appel refusé',
    logYouDeclined: 'Tu as refusé l’appel',
    logCancelled: 'Appel annulé',
    ended: 'Appel terminé',
    accept: 'Répondre',
    decline: 'Refuser',
    hangUp: 'Raccrocher',
    close: 'Fermer',
    mute: 'Couper le micro',
    unmute: 'Activer le micro',
    cameraOff: 'Couper la caméra',
    cameraOn: 'Activer la caméra',
    flipCamera: 'Changer de caméra',
    audioOutput: 'Sortie audio : {route}',
    audioOutputTitle: 'Choisir la sortie audio',
    earpiece: 'Écouteur',
    speaker: 'Haut-parleur',
    bluetooth: 'Bluetooth',
    bluetoothPermissionDenied: 'L’autorisation Bluetooth est désactivée. Active-la dans Réglages.',
    wiredHeadset: 'Casque filaire',
    audioRouteFailed: 'Impossible de changer la sortie audio',
    acceptFailed: 'Impossible de répondre à l’appel. Réessaie.',
    declineFailed: 'Impossible de refuser l’appel. Réessaie.',
    endFailed: 'Impossible de mettre fin à l’appel. Réessaie.',
    mediaConnectionFailed: 'La connexion audio n’a pas pu être établie. L’appel s’est terminé sans frais.',
    remaining: '{time} restant',
    endingSoon: 'Cet appel va bientôt se terminer.',
    spent: '{amount} dépensé',
    earned: '{amount} gagné',
    noAudioNotice: 'Cette version ne transmet pas encore le son. Le déroulement de l’appel et la facturation sont en cours de test.',
    failed: 'Impossible de lancer l’appel',
    insufficient: 'Ton solde est insuffisant pour cet appel',
    busy: 'La personne est déjà en appel',
    notAllowed: 'Avant d’appeler, il doit y avoir au moins un message dans la conversation avec cette personne',
    notAccepting: 'Cette personne n’accepte pas d’appels pour le moment',
    priceFree: 'Gratuit',
    priceChanged: 'Le tarif d’appel a changé. Regarde le nouveau tarif et réessaie.',
    rateLimited: 'Tu as effectué trop de tentatives d’appel. Patiente un peu et réessaie.',
    reservationLinkUnavailable: 'Cette réservation ne peut plus être liée à l’appel. Tu peux lancer un appel ordinaire à la place.',
    missed: 'Appel manqué',
    callNow: 'Appeler maintenant',
    videoNow: 'Appeler en vidéo',
    scheduledStartTitle: 'Appel planifié',
    scheduledStartBody: 'Ton appel planifié avec {name} commence. Appeler maintenant ?',
    schedule: 'Planifier un appel',
    scheduleTitle: 'Planifier un appel avec {name}',
    subjectPlaceholder: 'Objet (facultatif)',
    priceNote: 'Tarif de l’appel : {price}',
    sendReservation: 'Envoyer la demande de réservation',
    reservationSent: 'Demande envoyée',
    reservationSentBody: 'Ta demande de réservation d’appel a été envoyée à {name}.',
    reservationFailed: 'Impossible d’envoyer la demande de réservation d’appel',
    reservationBubble: '☎️ Réservation d’appel demandée',
    reservationBubbleShort: '☎️ Réservation d’appel',
    reservationLabel: 'Réservation d’appel vocal',
    rescheduleBubble: '☎️ Nouvel horaire d’appel proposé',
    rescheduleBubbleShort: '☎️ Nouvel horaire d’appel',
  },
  wallet: {
    title: 'Portefeuille',
    failed: 'Impossible de charger le portefeuille',
    availableBalance: 'Solde disponible',
    earningsTitle: 'Mes revenus',
    earningsTotal: 'Total gagné',
    earningsWithdrawable: 'Disponible pour un retrait',
    earningsEscrow: 'Sous séquestre',
    addFunds: 'Ajouter des fonds',
    addFundsDemo: 'Démo : ajoute un solde de test à ton compte',
    addFundsFailed: 'Impossible d’ajouter des fonds.',
    topupLabel: 'Fonds ajoutés',
    transactions: 'Transactions',
    noTransactions: 'Aucune transaction pour le moment',
    waiting: 'en attente',
    incomingRequest: 'demande reçue',
    replied: 'répondu',
    earned: 'gagné',
    refunded: 'Remboursé',
    requestPayout: 'Retirer',
    payoutHint: 'Tu peux retirer jusqu’à {amount}.',
    payoutAll: 'Sélectionner le montant total',
    payoutRequested: 'Demande reçue',
    payoutRequestedBody: 'Une demande de retrait de {amount} a été créée et sera traitée sous peu.',
    payoutFailed: 'Impossible de créer la demande de retrait',
    payoutRequests: 'Demandes de retrait',
    noPayouts: 'Aucune demande de retrait pour le moment',
    payoutStatusPending: 'En attente',
    payoutStatusPaid: 'Payé',
    payoutStatusRejected: 'Rejeté',
    paymentAccount: 'Compte de paiement',
    stripeConnect: 'Connecter un compte de paiement',
    stripeConnectInfo: 'Relie ton compte bancaire pour recevoir tes gains (Stripe, mode test)',
    stripeConnected: 'Connecté',
    stripeConnectFailed: 'Connexion impossible',
  },
  calendar: {
    dateInputLabel: "Date",
    timeInputLabel: "Heure",
    dateInputHint: "Saisis l’année, le mois et le jour au format YYYY-MM-DD.",
    timeInputHint: "Saisis l’heure au format 24 heures : HH:MM.",

    previousWeek: 'Semaine précédente',
    nextWeek: 'Semaine suivante',
    empty: 'Aucune demande à afficher',
    failed: 'Impossible de charger le calendrier',
    statusPending: 'En attente',
    statusAccepted: 'Acceptée',
    statusDeclined: 'Refusée',
    statusCancelled: 'Annulée',
    statusExpired: 'Expirée',
    accept: 'Accepter',
    decline: 'Refuser',
    cancel: 'Annuler',
    cancelConfirmationTitle: 'Annuler cette réservation ?',
    cancelConfirmationAcceptedBody: 'La réservation confirmée avec {name} sera annulée. L’autre personne sera prévenue et cette action sera irréversible.',
    cancelConfirmationPendingBody: 'La proposition envoyée à {name} sera retirée. L’autre personne sera prévenue et cette action sera irréversible.',
    actionFailed: 'Échec de l’action',
    proposeTitle: 'Proposer une rencontre avec {name}',
    locationPlaceholder: 'Où ? (facultatif)',
    sendProposal: 'Envoyer la proposition',
    proposalSent: 'Proposition envoyée',
    proposalSentBody: 'Ta proposition de rencontre a été envoyée à {name}.',
    priceChangedBody: 'Le tarif à la minute de cette réservation est maintenant de {amount}. Aucune proposition n’a été créée — vérifie le nouveau tarif et envoie une nouvelle proposition.',
    proposalFailed: 'Impossible d’envoyer la proposition',
    meetupBubble: '📅 Rencontre proposée',
    meetupBubbleShort: '📅 Proposition de rencontre',
    proposeAction: '📅 Proposer une rencontre',
    priceNote: 'Tarif de la rencontre : {price}',
    totalCost: 'Total : {amount}',
    minutesShort: 'min',
    tabRequests: 'Demandes',
    tabCalendar: 'Calendrier',
    tabActive: 'En cours',
    tabHistory: 'Historique',
    loadMore: 'Voir plus',
    noEventsForDay: 'Aucun événement ce jour-là',
    meetupLabel: 'Rencontre en personne',
    reservationDetails: 'Détails de la réservation',
    reservationParticipant: 'Personne',
    reservationHeld: 'L’appel a eu lieu',
    reservationNotHeld: 'Aucun appel n’a été passé',
    reservationDateTime: 'Date et heure',
    reservationDuration: 'Durée',
    reservationRate: 'Par minute',
    reservationLocation: 'Lieu',
    reservationSubject: 'Sujet',
    reservationQuotedTotal: 'Total proposé',
    reservationBilledDuration: 'Durée facturée',
    reservationSpentAmount: 'Montant payé',
    reservationEarnedAmount: 'Montant gagné',
    reservationSettledAt: 'Réglé le',
    reservationCreated: 'Créée le',
    reservationResponded: 'Réponse',
    reservationAcceptedAt: 'Acceptée',
    reservationDeclinedAt: 'Refusée',
    reservationCancelledAt: 'Annulée',
    reservationCancelledBy: 'Annulée par',
    reservationYou: 'Toi',
    reservationCancellationNotification: 'Envoi de la notification',
    reservationNotificationPending: 'En préparation',
    reservationNotificationProviderAccepted: 'Acceptée par le service d’envoi',
    reservationNotificationSuppressed: 'Non envoyée en raison des préférences de notification',
    reservationNotificationUnavailable: 'Aucun appareil admissible trouvé',
    reservationPendingReschedule: 'Nouvel horaire proposé',
    reservationNewTime: 'Nouvelle date et heure',
    proposeNewTime: 'Proposer un nouvel horaire',
    rescheduleFuture: 'Le nouvel horaire doit être à venir et différer d’au moins une minute de l’heure de début actuellement prévue.',
    reservationCallTooEarly: 'Cet appel planifié sera disponible 15 minutes avant son début.',
    reservationCallExpired: 'La fenêtre d’appel de cette réservation est terminée.',
    reservationCallInProgress: 'L’appel associé à cette réservation a déjà commencé.',
    reservationExecutionLocked: 'Cet appel planifié ne peut plus être modifié, car il a commencé ou s’est terminé.',
    openReservation: 'Ouvrir les détails de la réservation avec {name}',
    systemEventMeetupTitle: 'Rencontre avec {name}',
    systemEventCallTitle: 'Appel planifié avec {name}',
    systemEventNotes: 'Accepté via nosubject.',
    systemCalendarCopyRemoved: 'La copie du calendrier système a été supprimée',
    restoreSystemCalendarCopy: 'Restaurer',
    systemCalendarRestoreFailed: 'Impossible de restaurer la copie du calendrier. Vérifie les connexions et l’autorisation système.',
    systemCalendarCopyChanged: 'L’heure du calendrier système a été modifiée',
    reviewSystemCalendarChange: 'Examiner',
    systemCalendarChangeTitle: 'Heure du calendrier modifiée',
    systemCalendarChangeBody: 'Cette modification n’a pas été appliquée à l’autre personne.\n\nnosubject : {nosubject}\nCalendrier système : {system}',
    restoreNosubjectTime: 'Rétablir l’heure nosubject',
    systemCalendarTimeRestoreFailed: 'Impossible de corriger l’heure de la copie. Vérifie les connexions et l’autorisation système.',
    proposeReschedule: 'Proposer à l’autre personne',
    rescheduleSent: 'Nouvel horaire proposé',
    rescheduleSentBody: 'Ton nouvel horaire a été envoyé à {name}. L’horaire actuel reste valable jusqu’à son acceptation.',
    rescheduleFailed: 'Impossible de proposer le nouvel horaire.',
    rescheduleActionFailed: 'Impossible de mettre à jour la proposition d’horaire.',
    reschedulePendingReceived: 'Nouvel horaire proposé : {time}',
    reschedulePendingSent: 'Nouvel horaire en attente de réponse : {time}',
    withdrawReschedule: 'Retirer la proposition',
    rescheduleBubble: '📅 Nouvel horaire de rencontre proposé',
    rescheduleBubbleShort: '📅 Nouvel horaire de rencontre',
    connectionsTitle: 'Connexions de calendrier',
    connectionsInfo: 'Choisis les calendriers à afficher',
    deviceCalendar: 'Calendriers de l’appareil',
    connect: 'Connecter',
    openSettings: 'Ouvrir les réglages',
    permissionGranted: 'Accès autorisé',
    permissionDenied: 'Accès désactivé',
    permissionUnavailable: 'Indisponible dans cette version',
    permissionNotRequested: 'Pas encore connecté',
    devicePermissionInfo: 'L’autorisation n’est demandée qu’après avoir touché ce bouton. nosubject lit uniquement les calendriers choisis et la période nécessaire ; aucun événement n’est écrit depuis cet écran.',
    selectCalendars: 'Calendriers à afficher',
    noDeviceCalendars: 'Aucun calendrier d’événements n’est disponible sur cet appareil.',
    manageSystemPermission: 'Gérer l’autorisation du calendrier',
    connectionPrivacyInfo: 'Ta sélection reste sur cet appareil pour ce compte. Les détails externes servent uniquement à ton affichage et ne sont pas partagés automatiquement.',
    newBuildRequired: 'Une version plus récente est requise pour connecter des calendriers.',
    connectionFailed: 'Impossible de connecter le calendrier.',
    disconnect: 'Déconnecter',
    disconnectTitle: 'Déconnecter le calendrier ?',
    disconnectBody: 'nosubject cessera de lire les calendriers et d’écrire les nouveaux événements acceptés sur cet appareil. Les sélections et associations locales seront effacées ; les événements existants du calendrier système resteront. Tu peux révoquer séparément l’autorisation système dans les réglages de l’appareil.',
    disconnectFailed: 'Impossible de déconnecter le calendrier.',
    selectionSaveFailed: 'Impossible d’enregistrer la sélection.',
    allDay: 'Toute la journée',
    recurring: 'Récurrent',
    availabilityFree: 'Libre',
    availabilityBusy: 'Occupé',
    availabilityTentative: 'Provisoire',
    availabilityUnavailable: 'Indisponible',
    untitledExternalEvent: 'Événement sans titre',
    externalEventsFailed: 'Impossible de charger les événements externes.',
    hideExternalEvent: 'Masquer {title} dans cette vue',
    hideExternalEventFailed: 'Impossible de masquer l’événement.',
    restoreHiddenExternalEvents: 'Afficher à nouveau les événements masqués',
    restoreHiddenExternalEventsFailed: 'Impossible d’afficher à nouveau les événements masqués.',
    hiddenExternalEventCount: '{count} événements masqués sur cet appareil',
    checkIncompleteTitle: 'Vérification du calendrier incomplète',
    checkIncompleteBody: 'Au moins une source de calendrier est temporairement inaccessible. Nous ne pouvons donc pas confirmer que ce créneau est entièrement libre. Tu peux tout de même continuer.',
    conflictCheckIncomplete: 'Certains calendriers sont inaccessibles ; il peut donc y avoir d’autres conflits.',
    conflictTitle: 'Conflit de calendrier',
    reservationUnavailable: 'Ce créneau n’est plus disponible en raison d’une autre réservation confirmée.',
    reservationChanged: 'Cette réservation a été modifiée sur un autre écran ou appareil. Nous avons chargé la version la plus récente.',
    reservationPast: 'Une réservation dont l’heure de début est passée ne peut pas être acceptée.',
    conflictBody: 'Cet horaire chevauche un autre événement de ton calendrier. Tu peux tout de même continuer.',
    tentativeConflictTitle: 'Événement provisoire dans le calendrier',
    tentativeConflictBody: 'Un événement du calendrier à cette heure n’est pas encore confirmé. Vérifie les détails avant de continuer.',
    conflictMore: '• Autres événements : {count}',
    continueAnyway: 'Continuer quand même',
    onlineCalendars: 'Calendriers en ligne',
    googleCalendar: 'Google Agenda',
    providerConnected: 'Connecté',
    providerNotConnected: 'Non connecté',
    providerUnavailable: 'La connexion officielle est en préparation',
    googlePrivacyInfo: 'Seuls les calendriers que tu choisis sont synchronisés. Les titres et les lieux sont chiffrés dans un cache serveur minimal ; les descriptions, participants et liens de visioconférence ne sont pas conservés. nosubject ne peut ni créer, ni modifier, ni supprimer d’événement Google Agenda.',
    googleConnectionFailed: 'Impossible de démarrer la connexion à Google Agenda.',
    microsoftCalendar: 'Agenda Microsoft',
    microsoftInfo: 'nosubject lit uniquement ta disponibilité (Calendars.Read). Il ne peut pas créer, modifier ni supprimer d’événements. L’accès se retire dans les paramètres de ton compte Microsoft ; nosubject ne peut pas le révoquer lui-même.',
    microsoftConnectionFailed: 'Impossible de démarrer la connexion à l’agenda Microsoft.',
    googleDisconnectTitle: 'Déconnecter Google Agenda ?',
    googleDisconnectBody: 'nosubject cessera d’accéder aux données de Google Agenda et révoquera les autorisations Google que tu as accordées à nosubject. Aucun événement de Google Agenda ne sera supprimé.',
    googleDisconnectFailed: 'Impossible de déconnecter Google Agenda.',
    googleNoCalendars: 'Aucun calendrier Google lisible n’a été trouvé.',
    googleSelectionSaveFailed: 'Impossible d’enregistrer la sélection Google Agenda.',
  },
  instagram: {
    title: 'Connexion Instagram',
    connectInfo: 'Connecte ton compte professionnel avec un consentement explicite',
    connectedAccounts: 'Comptes connectés',
    professionalAccount: 'Compte professionnel',
    connect: 'Connecter',
    reconnect: 'Reconnecter',
    connectedAs: '@{username} · {accountType}',
    notConnected: 'Pas encore connecté',
    unavailable: 'La connexion officielle est en préparation',
    privacyInfo: 'La première étape demande uniquement instagram_business_basic pour lire l’identité du compte professionnel. Aucun accès aux messages, commentaires ou publications n’est demandé, et aucune photo n’est copiée vers nosubject sans choix d’importation distinct.',
    business: 'Entreprise',
    creator: 'Créateur',
    connectionFailed: 'Impossible de démarrer la connexion Instagram.',
  },
  inbox: {
    markUnread: 'Marquer comme non lu',
    markRead: 'Marquer comme lu',
    archiveTitle: 'Archives',
    archive: 'Archives',
    failed: 'Impossible de charger les conversations',
    searchEmpty: 'Aucun résultat',
    archivedEmpty: 'Aucune conversation archivée',
    empty: 'Aucune conversation pour le moment',
    you: 'Toi :',
    archived: 'Archivée',
    unarchived: 'Désarchivée',
    undo: 'Annuler',
    mute: 'Mettre en sourdine',
    muteTitle: 'Mettre {name} en sourdine',
    mute1h: 'Pendant 1 heure',
    mute8h: 'Pendant 8 heures',
    mute1w: 'Pendant 1 semaine',
    muteForever: 'Indéfiniment',
    unmute: 'Réactiver les notifications',
    archiveAction: 'Archiver',
    unarchiveAction: 'Désarchiver',
    swipeRemove: 'Désarchiver',
    swipeArchive: 'Archiver',
    blockAction: 'Bloquer',
    blockTitle: 'Bloquer {name} ?',
    blockMessage: 'Cette personne ne pourra plus t’envoyer de messages ni te trouver dans l’onglet Découvrir.',
    blockConfirm: 'Bloquer',
  },
  message: {
    translationLanguage: "Langue de traduction",
    chooseTranslationLanguage: "Choisir une langue de traduction",
    languageSuggestion: "Suggestion de la langue de l’appareil",
    translationLanguageInfo: "Cette préférence privée s’applique aux traductions de toutes tes conversations. Elle n’est pas ajoutée à ton profil.",
    photoCaption: "Ajouter une légende à la photo…",
    removePhoto: "Retirer la photo",
    star: "Ajouter une étoile",
    unstar: "Retirer l’étoile",
    starred: "Messages favoris",
    noStars: "Aucun message favori dans cette conversation.",
    starFailed: "Impossible de mettre à jour les favoris. Réessayez.",
    starredAttachment: "Message avec pièce jointe",
    edit: "Modifier le message",
    edited: "Modifié",
    editInfo: "Tu peux modifier le message tant qu’il n’est pas lu, même sans accusés de lecture. La disparition de Modifier peut révéler sa lecture. Non lu ne veut pas dire non vu : le texte initial a pu apparaître dans une notification. Modifier ne garantit pas de reprendre ses paroles.",
    editFailed: "Impossible de confirmer la modification. Le message a peut-être été lu ou modifié. Vérifie la conversation avant de réessayer.",
    copy: "Copier",
    copyFailed: "Impossible de copier le message. Réessaie.",
    inputPlaceholder: 'Écris un message…',
    typing: 'En train d’écrire',
    translate: 'Traduire',
    withdrawn: 'Message retiré',
    linkOpenTitle: 'Ouvrir le lien',
    linkOpenBody: 'Cela t’emmène vers {host}. Le lien a été envoyé par la personne qui t’écrit — prudence si tu ne la connais pas.',
    linkOpenConfirm: 'Ouvrir',
    linkOpenFailed: 'Le lien n’a pas pu être ouvert.',
    seenAt: 'Vu {time}',

    priceChangedTitle: 'Le prix a changé',
    priceChangedBody: 'Ce message coûte maintenant {new} et non {old}. L’envoyer quand même ?',
    priceChangedSend: 'Envoyer',
    priceNoticeTitle: 'Tarifs pour parler à cette personne',
    priceNoticeMessage: '{amount} par message',
    priceNoticeCall: 'Appels {amount}',
    priceNoticePersonal: 'Ces tarifs ont été fixés spécialement pour toi.',
    priceDecreasedTitle: "Le prix des messages a baissé",
    priceDecreasedBody: "Les messages coûtent désormais {new} au lieu de {old}. Aucune confirmation n’est nécessaire pour ce tarif réduit.",
    priceChange: {
      free: 'gratuit',
    },
    expired: 'expiré, remboursé',
    // 9.2 / D-650 — web'den gönderilen mesajın saat satırındaki notu.
    sentFromWeb: 'depuis le web',
    linkViewLabel: 'Affichage du lien',
    linkViewPlain: 'Adresse simple',
    linkViewCompact: 'Compact',
    linkViewCard: 'Grande carte',
    linkPreviewLoading: 'Préparation de l’aperçu…',
    linkPreviewFailed: 'Impossible d’obtenir un aperçu de ce lien ; il partira comme adresse simple.',
    linkPreviewA11y: 'Lien : {title}, {host}',
    customPrice: 'Prix personnalisé',
    priceUsesGeneral: 'Mon tarif général s’applique',
    priceRemove: 'Retirer des contacts',
    priceRemoveTitle: 'Retirer {name} de tes contacts ?',
    priceRemoveBody: 'Le prix personnalisé disparaît et {name} revient à ton prix général. Si seuls tes contacts peuvent t’écrire, cette personne ne pourra plus lancer de conversation. Ce n’est pas un blocage.',
    priceRemoveConfirm: 'Retirer',
    priceRemoved: '{name} revient à ton prix général.',
    pricePrompt: 'Tarifs pour {name} (0 = gratuit) :',
    saved: 'Enregistré',
    priceFreeSet: '{name} peut maintenant t’écrire gratuitement.',
    priceSet: 'Prix pour {name} fixé à {price}.',
    saveError: 'Impossible d’enregistrer.',
    photoError: 'Impossible d’envoyer la photo.',
    noConnection: 'Pas de connexion',
    checkInternet: 'Vérifie ta connexion internet.',
    sendError: 'Impossible d’envoyer le message.',
    addAttachment: 'Ajouter une pièce jointe',
    sendMessageAction: 'Envoyer le message',
    lowBalanceTitle: 'Solde insuffisant',
    lowBalanceBody: 'Ton solde est insuffisant pour envoyer un message à cette personne. Ajoute des fonds et réessaie.',
    reply: 'Répondre',
    reactionA11y: 'Réaction {emoji}, {count} au total',
    reactionA11yMine: 'Réaction {emoji}, {count} au total, dont la tienne',
    reactionAdd: 'Réagir avec {emoji}',
    moreReactions: 'Autres emojis',
    reactionRemove: 'Retirer ta réaction {emoji}',
    you: 'Toi',
    photo: '📷 Photo',
    takePhoto: 'Prendre une photo',
    choosePhoto: 'Choisir dans la photothèque',
    chooseVideo: 'Choisir une vidéo',
    recordVoice: 'Message vocal',
    micPermissionTitle: 'Accès au micro nécessaire',
    micPermissionBody: 'L’enregistrement d’un message vocal nécessite l’accès au micro.',
    voiceError: 'Impossible d’envoyer le message vocal',
    voiceRecording: 'Enregistrement',
    videoTooLarge: 'La vidéo est trop volumineuse (1 Go maximum)',
    videoTooLong: 'La vidéo est trop longue (10 minutes maximum)',
    videoError: 'Impossible d’envoyer la vidéo',
    videoNeedsUpdate: 'Mets à jour l’application pour regarder cette vidéo',
    voiceNeedsUpdate: 'Mets à jour l’application pour écouter ce message vocal',
    voiceOrderTitle: 'Message vocal commandé',
    encrypted: 'Message chiffré',
    identityChanged: 'La clé de sécurité de cette personne a changé. Cela signifie généralement un nouveau téléphone ou une application réinstallée.',
    identityChangedVerify: 'Tu avais vérifié cette conversation. Compare à nouveau le numéro de sécurité.',
    unencrypted: 'Cette conversation n’est pas chiffrée',
    unencryptedPeerInfo: 'L’application de l’autre personne ne prend pas encore en charge le chiffrement de bout en bout : ce que tu écris ici part donc sans chiffrement et peut être lu sur le serveur de nosubject. Quand elle mettra son application à jour, les nouveaux messages seront chiffrés automatiquement.',
    unencryptedOfficialInfo: 'C’est le compte officiel de nosubject. Ce que tu écris ici part sans chiffrement et peut être lu par l’équipe nosubject.',
    unencryptedSelfInfo: 'Le chiffrement n’a pas pu être activé sur cet appareil (par exemple, une fenêtre de navigation privée ne peut pas garder de clés). Ce que tu envoies d’ici part sans chiffrement et peut être lu sur le serveur de nosubject.',
    notificationOfferEnable: 'Activer les notifications',
    notificationOfferEnabled: 'Les notifications sont activées',
    voiceOrderPending: 'En attente de livraison',
    voiceOrderDelivered: 'Livré',
    voiceOrderDeclined: 'Refusé, remboursé',
    voiceOrderExpired: 'Expiré, remboursé',
    voiceOrderAction: 'Commander un message vocal',
    voiceOrderPick: 'Quelle durée d’enregistrement ?',
    voiceOrderInsufficient: 'Ton solde ne suffit pas pour cette commande.',
    voiceOrderError: 'La commande n’a pas pu être passée.',
    voiceOrderRecord: 'Enregistrer et envoyer',
    voiceOrderDecline: 'Refuser',
    voiceOrderDeclineTitle: 'Refuser la commande',
    voiceOrderDeclineBody: 'La totalité du montant réservé revient à la personne qui a commandé.',
    voiceOrderDeclineError: 'La commande n’a pas pu être refusée.',
    voiceOrderDeliverError: 'L’enregistrement n’a pas pu être livré.',
    voiceOrderRecording: 'Enregistrement commandé',
    voiceOrderRemaining: 'Il reste {length}',
    voiceOrderShortNote: 'Envoie plus court et seul ce que tu enregistres est payé.',
    voiceOrderRefunded: '{amount} remboursé',
    sendLocation: 'Envoyer la position',
    locationTitle: 'Position',
    locationError: 'La position n’a pas pu être envoyée',
    shareLiveLocation: 'Partager la position en direct',
    liveLocationHour: '1 heure',
    liveLocationEightHours: '8 heures',
    liveLocationOpenEnded: 'Jusqu’à ce que je l’arrête',
    liveLocationSharing: 'Ta position en direct est partagée',
    liveLocationStop: 'Arrêter',
    liveLocationError: 'La position en direct n’a pas pu démarrer',
    liveLocationCardTitle: 'Position en direct',
    liveLocationCardActive: 'Partage en cours',
    liveLocationCardEnded: 'Partage terminé',
    liveLocationOpen: 'Voir la position',
    liveLocationNoPoint: 'Pas encore de position',
    liveLocationOpenInMaps: 'Ouvrir dans Plans',
    liveLocationUpdatedAgo: 'Mis à jour {ago}',
    videoShort: '🎬 Vidéo',
    voiceShort: '🎙 Message vocal',
    liveLocationWatchedAgo: 'Consultée il y a {ago}',
    liveLocationNotWatched: 'Pas encore consultée',
    liveLocationSharerSeesYou: 'Elle voit quand tu regardes',
    cameraPermissionTitle: 'Accès à la caméra requis',
    cameraPermissionBody: 'Autorise l’accès à la caméra pour prendre une photo.',
    cameraError: 'Impossible d’ouvrir la caméra.',
    photoLocationTitle: 'Lieu de la photo',
    photoLocationPromptFile: '{place} a été lu dans le fichier photo. Afficher ce lieu avec la photo ?',
    photoLocationPromptCapture: 'La position de l’appareil indique {place}. Afficher ce lieu avec la photo ?',
    photoLocationHide: 'Envoyer sans lieu',
    photoLocationShare: 'Envoyer avec le lieu',
    photoLocationFromFile: 'Lu dans le fichier',
    photoLocationFromCapture: 'Position de l’appareil',
    photoLocationHideAfter: 'Masquer le lieu',
    photoLocationShowAfter: 'Afficher le lieu',
    photoLocationUpdateError: 'Impossible de mettre à jour le lieu de la photo.',
  },
  versionNotice: {
    title: 'Une nouvelle version est disponible',
    body: 'Mets l’app à jour pour la sécurité et les nouvelles fonctionnalités.',
    update: 'Mettre à jour',
  },
  notifications: {
    title: 'Notifications',
    cardBody: 'Active les notifications de l’appareil pour ne manquer aucun message ni réponse.',
    notNow: 'Pas maintenant',
    enable: 'Activer les notifications',
    device: 'Notifications de l’appareil',
    stateOn: 'Activées · Gérer dans les réglages',
    stateOff: 'Désactivées · Activer dans les réglages',
    stateAsk: 'Pas encore demandé',
    preferences: 'Préférences de notification',
    preferencesInfo: 'Gérer les catégories, aperçus et autorisations de l’appareil',
    stateUnsupported: 'Non pris en charge sur cet appareil',
    master: 'Toutes les notifications',
    masterInfo: 'Si tu désactives cette option, tu ne reçois plus aucune notification push. Les réglages des catégories sont conservés',
    categories: 'Catégories',
    categoryEnabled: 'Notifications de cette catégorie',
    categoryEnabledInfo: 'Si tu désactives cette option, tu ne reçois plus de notifications push de cette catégorie. Ses réglages sont conservés',
    events: 'Événements',
    messages: 'Messages',
    messagesInfo: 'Nouveaux messages et réponses',
    meetups: 'Rencontres',
    meetupsInfo: 'Propositions, modifications et résultats',
    meetupRequests: 'Nouvelles propositions de rencontre',
    meetupRequestsInfo: 'Quand une nouvelle rencontre t’est proposée',
    meetupUpdates: 'Réponses et annulations',
    meetupUpdatesInfo: 'Quand une rencontre est acceptée, refusée ou annulée',
    meetupReminders: 'Rappels de rencontres',
    meetupRemindersInfo: 'Quand une rencontre acceptée approche',
    calls: 'Appels',
    callsInfo: 'Appels entrants, planifiés et manqués',
    incomingCalls: 'Appels entrants',
    incomingCallsInfo: 'Une alerte sonore lorsque quelqu’un t’appelle',
    callRequests: 'Propositions d’appel planifié',
    callRequestsInfo: 'Quand une proposition est créée, acceptée, refusée ou annulée',
    callReminders: 'Rappels d’appels',
    callRemindersInfo: 'Quand un appel accepté approche',
    missedCalls: 'Appels manqués',
    missedCallsInfo: 'Quand tu n’as pas pu répondre à un appel',
    financial: 'Argent et séquestre',
    financialInfo: 'Changements d’état des transactions',
    financialEarnings: 'Gains et séquestre',
    financialEarningsInfo: 'Quand le séquestre est libéré ou qu’un gain est disponible',
    financialRefunds: 'Remboursements et expiration',
    financialRefundsInfo: 'Quand un paiement est remboursé ou que le séquestre expire',
    financialPayouts: 'Résultats des retraits',
    financialPayoutsInfo: 'Quand une demande de retrait aboutit ou échoue',
    reactions: 'Réactions emoji',
    reactionsInfo: 'Réactions à tes messages',
    official: 'De Nosubject',
    officialInfo: 'Les annonces de Nosubject sur les versions, la sécurité et ton compte. Indépendant de tes autres notifications : si tu le désactives, Nosubject n’envoie plus de notifications, mais ses messages arrivent toujours dans ta boîte.',
    preview: 'Aperçu du message',
    previewHidden: 'Masqué',
    previewHiddenInfo: 'Ne montrer ni l’expéditeur ni le message',
    previewSender: 'Expéditeur uniquement',
    previewSenderInfo: 'Afficher l’expéditeur et masquer le message',
    previewText: 'Expéditeur et message',
    previewTextInfo: 'Afficher jusqu’à 80 caractères',
    deviceInfo: 'L’autorisation système est propre à cet appareil',
    openSettings: 'Ouvrir les réglages',
    centerTitle: 'Centre de notifications',
    centerMarkAll: 'Tout marquer comme lu', centerMarkedAll: 'Tout est marqué comme lu',
    centerEmpty: 'Aucune notification pour le moment.',
    centerFailed: 'Impossible de charger les notifications.',
    centerMarkAllFailed: 'Impossible de marquer les notifications comme lues.',
    centerUnknownPerson: 'Quelqu’un',
    centerEscrowExpiredRefunded: 'Le séquestre a expiré · paiement remboursé',
    centerEscrowReleasedEarning: 'Réponse terminée · gains ajoutés',
    centerMeetupRequest: '{name} t’a envoyé une proposition de rencontre',
    centerCallRequest: '{name} t’a envoyé une proposition d’appel planifié',
    centerCallReminder: 'Ton appel planifié avec {name} approche',
    centerCallStarting: 'Ton appel planifié avec {name} commence',
    centerMeetupStarting: 'Ta rencontre avec {name} commence',
    centerMeetupReminder: 'Ta rencontre avec {name} approche',
    centerMeetupUpdate: '{name} · Rencontre : {status}',
    centerCallUpdate: '{name} · Réservation d’appel : {status}',
    centerMeetupRescheduleRequest: '{name} a proposé un nouvel horaire de rencontre',
    centerCallRescheduleRequest: '{name} a proposé un nouvel horaire d’appel',
    centerMeetupRescheduleUpdate: '{name} · Proposition d’horaire de rencontre : {status}',
    centerCallRescheduleUpdate: '{name} · Proposition d’horaire d’appel : {status}',
    centerBell: 'Centre de notifications',
    centerBellUnread: 'Centre de notifications, non lues : {count}',
  },
  profile: {
    webVisibility: 'Qui peut voir ma page web',
    webVisibilityLink: 'Avec le lien',
    webVisibilityInfo: 'Ton profil tel que le voient les personnes sans compte : ta page nosubject.co/ton-nom-d’utilisateur. Tout le monde : ta page peut aussi apparaître dans les moteurs de recherche. Avec le lien : qui a l’adresse peut l’ouvrir ; les moteurs de recherche ne la listent pas. Dans les deux cas, les personnes sans compte peuvent accéder aux informations de ton profil, y compris ta dernière connexion. Personne : personne sans compte ne peut voir ton profil ; la page affiche « Ce profil n’est pas disponible ». Ton profil dans l’app ne change pas. Sortir des résultats de recherche peut prendre quelques jours.',
    linkViewInfo: 'Choisis comment part un lien que tu écris. Avec Compact et Grande carte, ton téléphone ouvre la page une fois et envoie l’aperçu avec le message ; ce site voit l’adresse IP de ton téléphone. Dans une conversation chiffrée, l’aperçu est dans le chiffrement ; dans une conversation non chiffrée, nosubject voit le lien et l’aperçu. Adresse simple n’ouvre aucune page. Les liens envoyés depuis le web partent toujours en adresse simple.',
    linkViewAsk: 'Afficher les options pendant la saisie',
    linkViewAskInfo: 'Activé, les deux autres affichages apparaissent quand tu écris un lien, et tu peux en choisir un pour ce message. Désactivé, les liens partent toujours avec l’affichage choisi ici.',
    whoCanCallInfo: 'Choisis qui peut t’appeler ; cela s’applique à chaque appel. Mes contacts sont les personnes à qui tu as donné un prix personnel. Avec Exceptions, tu peux autoriser ou bloquer des personnes une par une.',
    whoCanMessageInfo: 'Choisis qui peut commencer une nouvelle conversation avec toi ; les conversations déjà commencées ne changent pas. Mes contacts sont les personnes à qui tu as donné un prix personnel. Avec Exceptions, tu peux autoriser ou bloquer des personnes une par une.',
    readReceiptsInfo: "Les accusés ne s’affichent que si les deux personnes les activent. Même désactivés, la disparition de Modifier peut révéler la lecture.",
    showTypingInfo: 'Activé, la personne à qui tu écris voit que tu es en train d’écrire. Désactivé, personne ne le voit, et tu continues de voir quand les autres écrivent.',
    officialAccount: 'Compte officiel',
    information: 'Informations du profil',
    logout: 'Se déconnecter',
    account: 'Compte',
    accountData: 'Compte et données',
    name: 'Prénom',
    surname: 'Nom',
    username: 'Nom d’utilisateur',
    usernamePlaceholder: 'nomdutilisateur',
    usernameChecking: 'Vérification…',
    usernameAvailable: 'Disponible',
    usernameTaken: 'Ce nom d’utilisateur est déjà pris',
    usernameInvalid: 'De 3 à 20 caractères. Commence par A–Z ou a–z ; ensuite, utilise A–Z, a–z, 0–9 ou _.',
    usernameAdd: 'Ajouter un nom d’utilisateur',
    profession: 'Profession',
    professionNone: 'Aucune profession ajoutée',
    professionAdd: 'Ajouter une profession',
    employer: 'Entreprise',
    employerPlaceholder: 'nomutilisateurentreprise',
    employerInfo: 'Saisis un nom d’utilisateur nosubject existant. Cette mention ne signifie pas que l’emploi est vérifié.',
    employerNotFound: 'Aucun compte actif ne correspond à ce nom d’utilisateur.',
    employerSelf: 'Tu ne peux pas indiquer ton propre compte comme entreprise.',
    bio: 'Parle-nous de toi…',
    prices: 'Tarifs',
    settings: 'Réglages',
    priceMessage: 'Message',
    priceVoice: 'Message vocal (par minute)',
    priceVoiceShort: 'Message vocal',
    priceCall: 'Appeler maintenant (par minute)',
    priceCallShort: 'Appeler maintenant',
    priceScheduledCall: 'Planifier un appel (par minute)',
    priceScheduledCallShort: 'Planifier un appel',
    priceVideoCall: 'Appel vidéo',
    priceVideoCallShort: 'Vidéo',
    priceTime: 'Rencontre (par minute)',
    priceTimeShort: 'Rencontre',
    currency: 'Devise',
    saving: 'Enregistrement…',
    wallet: 'Portefeuille',
    chatBackup: 'Sauvegarde des discussions',
    privacy: 'Confidentialité',
    readReceipts: 'Accusés de lecture',
    showTyping: 'Indicateur de saisie',
    keepArchived: 'Garder dans les archives',
    keepArchivedInfo: 'Si cette option est désactivée, un nouveau message désarchive la conversation',
    whoCanMessage: 'Qui peut m’écrire',
    whoCanCall: 'Qui peut m’appeler',
    messagesFromContact: 'Messages de cette personne',
    callsFromContact: 'Appels de cette personne',
    callExceptions: 'Exceptions',
    callExceptionsEmpty: 'Aucune exception pour l’instant',
    messageExceptionsEmpty: 'Pas encore d’exception pour les messages',
    exceptionsLoadFailed: 'Impossible de charger les exceptions',
    openProfileHint: 'Ouvre le profil de cette personne',
    callExceptionBlocked: 'Bloqué',
    callsFromContactDefault: 'Par défaut',
    callsFromContactAllow: 'Toujours autoriser',
    callsFromContactBlock: 'Jamais',
    everyone: 'Tout le monde',
    contacts: 'Mes contacts',
    nobody: 'Personne',
    blockedUsers: 'Utilisateurs bloqués',
    blockedEmpty: 'Tu n’as bloqué personne',
    unblock: 'Débloquer',
    appearance: 'Apparence',
    light: 'Clair',
    dark: 'Sombre',
    system: 'Système',
    displayLanguage: 'Langue de l’application',
    education: 'Université',
    educationAdd: 'Ajouter une université',
    educationNone: 'Aucune université ajoutée',

    educationLevel: 'Niveau d’études',
    searchLanguage: 'Rechercher une langue…',
    photoChange: 'Modifier',
    saveFailed: 'Impossible d’enregistrer.',
    photoFailed: 'Impossible d’envoyer la photo.',
    photoChanged: "La photo a été modifiée par une autre opération ou le délai de nouvelle tentative a expiré. Sélectionnez à nouveau la photo.",
    deleteAccount: 'Supprimer le compte',
    deleteTitle: 'Supprimer ton compte',
    deleteMessage: 'Ton compte sera supprimé définitivement après 30 jours. Tu peux te reconnecter pendant cette période pour annuler.',
    deleteMoneyWarning: 'Tu as {amount} dans ton portefeuille et en séquestre. Nous te recommandons de le retirer avant de supprimer ton compte.',
    deleteConfirm: 'Supprimer',
    deleteFailed: 'Impossible de supprimer le compte.',
    deletionScheduled: 'Ton compte sera supprimé le {date}.',
    deletionCancel: 'Annuler la suppression',
    exportData: 'Télécharger mes données',
    exportFailed: 'Impossible de récupérer les données.',
  },
  // Alt bar (dock) — ekran okuyucu etiketleri ve rozet sayıları (9.26.7.2.1)
  dock: {
    calls: 'Appels',
    discover: 'Découvrir',
    inbox: 'Messages',
    calendar: 'Calendrier',
    profile: 'Profil',
    unreadMessages: 'non lus : {count}',
    pendingRequests: 'en attente : {count}',
  },
};
